import { useState } from 'react';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [loadingCartable, setLoadingCartable] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [userBillNumber, setUserBillNumber] = useState(null);
  return {
    loading,
    setLoading,
    openDialog,
    setOpenDialog,
    userBillNumber,
    setUserBillNumber,
    loadingCartable, setLoadingCartable ,
    disabledBtn ,  setDisabledBtn
  };
};

export default useCustomHook;
